import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { LoggerService } from '@asset-solutions/shared/logging';
import { Observable, catchError, throwError } from 'rxjs';

import { API_CONFIG } from '../http.module';

export interface LoggingContext {
  log400: boolean;
}

export const LOGGING_CONTEXT = new HttpContextToken<LoggingContext>(() => ({ log400: true }));

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  private interceptorFn = loggingInterceptorFn;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.interceptorFn(req, next.handle);
  }
}

export const loggingInterceptorFn: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  const config = inject(API_CONFIG);

  return next(req).pipe(
    catchError((error) => {
      const context = req.context.get(LOGGING_CONTEXT);

      if (
        !req.url.startsWith(config.url) ||
        error.status === 401 ||
        (context.log400 === false && error.status === 400)
      ) {
        return throwError(() => error);
      }

      logger.error(error.name, error);
      return throwError(() => error);
    })
  );
};
